import { HTMLProps, useEffect, useRef } from "react";
import "../atomic/styles.css";

export interface IndeterminateCheckboxProps
  extends HTMLProps<HTMLInputElement> {
  indeterminate?: boolean;
  inlineForCenter?: boolean;
}

function IndeterminateCheckbox({
  indeterminate,
  className = "",
  inlineForCenter = false,
  ...rest
}: IndeterminateCheckboxProps) {
  const ref = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (ref.current) {
      ref.current.indeterminate = indeterminate ?? false;
    }
  }, [indeterminate]);

  return (
    <label
      className={`checkboxContainer ${inlineForCenter ? "icon-only" : "-mt-[10px] -mr-2"} ${className}`.trim()}
      style={
        inlineForCenter
          ? { marginTop: -3 } 
          : undefined
      }
      onClick={(e) => e.stopPropagation()}
    >
      <input
        type="checkbox"
        ref={ref}
        {...rest}
      />
      <span className="checkmark" />
    </label>
  );
}

export default IndeterminateCheckbox;
